module.exports = __webpack_public_path__ + "media/images/badges/rowhouse-badge-7b36ced0d0f413dd1f071029c98863fd.png";